import React from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import HeroImg from '../Components/HeroImg';

const Home = () => {
    return (
        <div>
            <Navbar/>
            <HeroImg/>
            <Footer/>
        </div>
    );
};
  
export default Home;